import { makeObservable, observable, runInAction, action } from 'mobx';
import { ExpenseService } from '../services/expenseServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import {
    getConfig, setConfig
} from './../../utils';
export default class InternalExpensesSummaryStore {

    rootStore;
    summary = {
        status: 0,
        expensesWithPackages: [],
        expensesWithActualCosts: [],
        expensesWithPackagesTotal: 0
    };

    criteria = {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        devId: undefined,
    }
    isLoading = false;

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            getSummary: action,
            getPreviousMonth: action,
            getNextMonth: action,
            summary: observable,
            criteria: observable,
            isLoading: observable,
            sendToValidate: action,
            checkCurrentMonth:action
        });
    }

   

    sendToValidate = async () => {
        try {
            runInAction(() => {
                this.isLoading = true;
            });

            await ExpenseService.sendToValidate(this.criteria);
            const data = await ExpenseService.getInternalSummary(this.criteria);
            runInAction(() => {
                this.summary = data;
            })
        } catch (error) {
            runInAction(() => {
                this.expenses = [];
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    checkCurrentMonth = async (accountInfo) => {
        runInAction(() => {
            var savedCurrent = getConfig("date", `current_${accountInfo.name}`);
            if (savedCurrent) {
                var d = new Date(savedCurrent);

                this.criteria.year = d.getFullYear();
                this.criteria.month = d.getMonth();
            }
        })
    }
    getSummary = async () => {
        try {
            runInAction(() => {
                this.isLoading = true;               
            });

            const data = await ExpenseService.getInternalSummary(this.criteria);
            runInAction(() => {
                this.summary = data;
            })
        } catch (error) {
            runInAction(() => {
                this.expenses = [];
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    getPreviousMonth = async (accountInfo) => {
        runInAction(() => {
            console.log(this.criteria)
            if (this.criteria.month == 0) {
                this.criteria.month = 11;
                this.criteria.year = this.criteria.year - 1;
            } else {
                this.criteria.month = this.criteria.month - 1;
            }

            this.getSummary();

            setConfig("date", `current_${accountInfo.name}`, new Date(this.criteria.year, this.criteria.month , 1));
        });
    }

    getNextMonth = async (accountInfo) => {
        runInAction(() => {
            if (this.criteria.month == 11) {
                this.criteria.month = 0;
                this.criteria.year = this.criteria.year + 1;
            } else {
                this.criteria.month = this.criteria.month + 1;
            }

            setConfig("date", `current_${accountInfo.name}`, new Date(this.criteria.year, this.criteria.month, 1));
            this.getSummary();
        });
    }    
}